module.exports = __webpack_public_path__ + "static/media/warningBlue.a019ce83.svg";